import moment from 'moment'

export default {
    components: {

    },
    filters: {
    },
    data() {
        return {

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
     * @description 看是否有跨日
     * serviceTimeSetting -> 所有營業時間
     * dayMinusOfTheWeek -> 減一天的星期幾：1 2 3 4 5
     * selectDay -> 要測試的日期：'2023/08/04'
     * selectTime -> 要測試的時間：'00:00'
     */
        isCrossOverTime(serviceTimeSetting, dayMinusOfTheWeek, selectDay, selectTime) {
            try {
                const { start: startTimeStr, end: endTimeStr } = serviceTimeSetting[dayMinusOfTheWeek]
                const startTime = moment(startTimeStr, 'HH:mm');
                const endTime = moment(endTimeStr, 'HH:mm');
                if (endTime.isAfter(startTime)) {
                    // 如果不是跨日 -> return true，開啟加價
                    return true
                } else {
                    // 如果是跨日 -> 返回看是否在營業時間之後 -> true:在營業時間之後
                    return moment(`${selectDay} ${selectTime}`).isAfter(moment(`${selectDay} ${endTimeStr}`))
                }
            } catch (error) {
                console.error(error.message)
            }

        },
        /**
         * @description 看是否在今日營業時間之內
         */
        isTodayTimeOk(serviceTimeSetting, dayMinusOfTheWeek, selectDay, selectTime) {
            try {
                const { start: startTimeStr, end: endTimeStr } = serviceTimeSetting[dayMinusOfTheWeek]
                const startTime = moment(startTimeStr, 'HH:mm');
                const endTime = moment(endTimeStr, 'HH:mm');
                // endTime.isAfter(startTime) -> true，代表正常沒有跨日的時間 -> 正常就要比較前後時間是否ok
                if (endTime.isAfter(startTime)) {
                    if (moment(`${selectDay} ${selectTime}`).isBefore(moment(`${selectDay} ${startTimeStr}`)) ||
                        moment(`${selectDay} ${selectTime}`).isAfter(moment(`${selectDay} ${endTimeStr}`))) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    // 如果跨日了，則直接比較開始時間就好
                    if (moment(`${selectDay} ${selectTime}`).isBefore(moment(`${selectDay} ${startTimeStr}`))) {
                        return true
                    } else {
                        return false
                    }
                }
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
         * @description 看是否結束服務時間有超越今天 -> 超越今天要去看明天的營業時間
         */
        isEndTimeOverDay(serviceTimeSetting, selectDay, addMinute) {
            const formatString = 'YYYY/MM/DD HH:mm';
            const endDateTime = moment(selectDay, formatString).add(addMinute, 'minutes').format(formatString); // 預約時間加上相加後的時間 = 結束服務時間
            const dayOfTheWeek = moment(endDateTime).day() === 0 ? 7 : moment(endDateTime).day(); // 取得星期幾(選擇當天)
            const startTime = new Date(moment(selectDay, formatString).format(formatString))
            const endTime = new Date(moment(endDateTime, formatString).format(formatString))
            const endTimeForHHMM = moment(endDateTime).format('HH:mm')
            const endTimeForYYYY = moment(endDateTime).format('YYYY/MM/DD')
            return this.isWithinServiceTime(serviceTimeSetting, startTime, endTime) && this.isCrossOverTime(serviceTimeSetting, dayOfTheWeek - 1 === 0 ? 7 : dayOfTheWeek - 1, endTimeForYYYY, endTimeForHHMM);
        },
        /**
         * @description 驗證是否有通過今日服務結束驗證
         * @returns 
         */
        isWithinServiceTime(serviceTimeSetting, startDateTime, endDateTime) {
            const startDay = startDateTime.getDay(); // 获取开始日期的星期几 (0 表示周日, 1 表示周一, 以此类推)
            const endDay = endDateTime.getDay(); // 获取结束日期的星期几

            // 如果开始日期和结束日期不在同一天，需要进行特殊处理
            if (startDay !== endDay) {
                // 營業時間可能跨到隔日，需要分别判断两天的情况
                const endDaySetting = serviceTimeSetting[endDay];
                const startDaySetting = serviceTimeSetting[startDay];
                const start = this.parseTimeString(endDaySetting.start);
                const end = this.parseTimeString(startDaySetting.end);
                const time = this.parseTimeString(moment(endDateTime).format('HH:mm'));
                // 开始日期和结束日期不在同一天 + 開始日期跨日營業 => 要去驗證結束營業時間與隔天開始日期
                if(this.parseTimeString(startDaySetting.start) >= this.parseTimeString(startDaySetting.end)){
                    if (start > time && end < time) {
                        return true;
                    }
                }
                // 开始日期和结束日期不在同一天 + 開始日期沒跨日 => 要去驗證隔天開始營業日期
                if (this.parseTimeString(startDaySetting.start) <= this.parseTimeString(startDaySetting.end)) {
                    if (start > time) {
                        return true;
                    }
                }

            } else {
                // 开始日期和结束日期在同一天，直接判断營業時間即可
                const timeSetting = serviceTimeSetting[startDay];
                if (this.isWithinTimeRange(timeSetting, endDateTime)) {
                    return false;
                } else {
                    return true
                }
            }
            return false;
        },
        /**
         * @description 看營業時間是否符合規定
         * @param {*} timeSetting 
         * @param {*} dateTime 
         * @returns 
         */
        isWithinTimeRange(timeSetting, dateTime) {
            const start = this.parseTimeString(timeSetting.start);
            const end = this.parseTimeString(timeSetting.end);
            const time = this.parseTimeString(moment(dateTime).format('HH:mm'));
            if (start <= end) {
                // 没有跨日營業時間
                return time >= start && time <= end;
            } else {
                // 跨日營業時間，例如：22:00 到 02:00
                return time >= start || time <= end;
            }
        },
        /**
         * @description 利用小時與時間去算出營業時間
         * ex: 00:00 -> 0
         * ex: 01:30 -> 90
         */
        parseTimeString(timeString) {
            const [hours, minutes] = timeString.split(":");
            return parseInt(hours) * 60 + parseInt(minutes);
        }
    }
}